import { Component, OnInit } from '@angular/core';
import {AvatarTypeEnum, DialogRef} from "datnek-ds";
interface UsersItems {
  imageSrc: string;
  professionalTitle: string;
  name: string;
  society: string;
  groupName: string;
  relations: number;
  sector: string;
}

@Component({
  selector: 'nk-shared-dialog-view-participants',
  templateUrl: './dialog-view-participants.component.html',
  styleUrls: ['./dialog-view-participants.component.scss'],
})
export class DialogViewParticipantsComponent implements OnInit {
  avatarEnum = AvatarTypeEnum;

  dataUsers: UsersItems[] = [
    {
      imageSrc: 'assets/Img/users/1.png',
      professionalTitle: 'Analyste Programmeur',
      name: 'Fara Moiten 2',
      society: 'DIGITAILLE',
      groupName: 'NOM DU GROUPE',
      relations: 4,
      sector: 'Génie civil',
    },
    {
      imageSrc: 'assets/Img/users/1.png',
      professionalTitle: 'Analyste Programmeur',
      name: 'Fara Moiten 2',
      society: 'DIGITAILLE',
      groupName: 'NOM DU GROUPE',
      relations: 18,
      sector: 'Technologie',
    },
    {
      imageSrc: 'assets/Img/users/1.png',
      professionalTitle: 'Analyste Programmeur',
      name: 'Fara Moiten 2',
      society: 'DIGITAILLE',
      groupName: 'NOM DU GROUPE',
      relations: 0,
      sector: 'Agroalimentaire',
    },
  ];

  constructor(public dialogRef: DialogRef) {}

  ngOnInit(): void {}
}
